import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * The merge knows Tailwind's radius and size names and not the ones `index.css`
 * adds by job. Without these, `rounded-control` and a caller's `rounded-inset`
 * both stayed on the element, and the stylesheet's order chose the token; and
 * `text-detail` read as a colour, so a caller's `text-muted-foreground` removed
 * the type size.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: { radius: ["control", "inset", "menu", "tip"], text: ["detail"] },
    classGroups: {
      w: [{ w: ["menu", "tip"] }],
      "max-w": [{ "max-w": ["tip"] }],
      "max-h": [{ "max-h": ["list", "list-short"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
